import { VehicleService } from "@services/vehicle.service";
import angular, { IPromise } from "angular";
import { IVehicle } from "@interfaces/IVehicle";
import { IAlertRuleRecord } from "../../../_models/alerts.interfaces";
import { IGeofence } from "@interfaces/IGeofences";
import { GeofenceService } from "@services/geofence.service";

export interface IGeofenceAlertDetailData {
    geofence?: IGeofence;
    vehicle?: IVehicle;
}

export class GeofenceAlertDetailService {

    static $inject = ["$q", "geofenceService", "vehicleService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly geofenceService: GeofenceService,
        private readonly vehicleService: VehicleService) {
    }

    getAlertExport(record: IAlertRuleRecord): IPromise<string> {
        return this.getAlertData(record).then((data) => {
            return `${this.createAlertLabel(data)}`;
        }).catch((error) => {
            console.error("Error retrieving geofence alert detail: ", error);

            return null
        });
    }

    createAlertLabel(data: IGeofenceAlertDetailData): string {
        return `${data.geofence?.Description}`;
    }

    getAlertData(record: IAlertRuleRecord): IPromise<IGeofenceAlertDetailData> {
        const promises = [];
        const data: IGeofenceAlertDetailData = {};

        promises.push(this.getGeofence(record, data));
        promises.push(this.getVehicle(record, data));

        return this.$q.all(promises).then(() => {
            return data;
        });
    }

    private getGeofence(record: IAlertRuleRecord, data: IGeofenceAlertDetailData): IPromise<void> {
        if (!record.alertMetadata.GeofenceId) {
            return this.$q.resolve();
        }

        return this.geofenceService.getGeofenceById(record.alertMetadata.GeofenceId).then(geofence => {
            data.geofence = geofence;
        });
    }

    private getVehicle(record: IAlertRuleRecord, data: IGeofenceAlertDetailData): IPromise<void> {
        if (!record.VehicleId) {
            return this.$q.resolve();
        }

        return this.vehicleService.getVehicles({ includePeripheralMappings: true })
            .then((vehicles) => {
                data.vehicle = vehicles.find(v => v.Id === record.VehicleId);
            });
    }
}
